import React, { useState, useRef, useEffect } from 'react'
import { FaUserCircle } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'
import { logout } from './redux/slices/user'
import { useDispatch, useSelector } from 'react-redux'
import CompanySearch from './company-search'
import AdminNavMenuDropdown from './admin-nav-menu-dropdown'
import { useAuth0 } from '@auth0/auth0-react'
import { REACT_APP_SERVER_ROOT } from './config'
import { companyAdminPath } from './impact-network-id'

type Props = {
  showCompanySearch: boolean
}

const NavUserDropdown: React.FC<Props> = ({ showCompanySearch }: Props) => {
  const dispatch = useDispatch()

  const history = useHistory()
  const { user } = useSelector(s => s.user)

  const { logout: auth0Logout } = useAuth0()

  const clearQueueCookieOnServer = (): void => {
    const iframeName = 'queue-logout-target'
    let iframe = document.getElementById(iframeName) as HTMLIFrameElement | null

    if (!iframe) {
      iframe = document.createElement('iframe')
      iframe.id = iframeName
      iframe.name = iframeName
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
    }

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${REACT_APP_SERVER_ROOT}/admin/queues/logout`
    form.target = iframeName
    form.style.display = 'none'

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  return (
    <div className="navbar-nav">
      {showCompanySearch && <div className="nav-item" style={{
        display: 'flex',
        alignItems: 'center',
        minWidth: '300px'
      }}>
        <CompanySearch
          onSelect={(id, co) => {
            history.push(companyAdminPath(id))
          }}
          placeholder="Company Search"
          clearAfterSelect
          hideNoResults={true}
          autoFocus={false}
          resultsStyle='dropdown-only'
          style={{ width: '100%' }}
        />
      </div>}
      <AdminNavMenuDropdown
        labelElement={<FaUserCircle style={{ fontSize: '2em', color: '#666' }} />}
        menuElements={<>
          <div className="dropdown-item">
            {user?.email || 'Unknown email'}
          </div>
          <a className="dropdown-item" href="#"
            onClick={() => {
              clearQueueCookieOnServer()
              dispatch(logout())
              auth0Logout({logoutParams: {returnTo: window.location.origin}})
              history.push('/login')
            }}
          >Logout</a>
        </>}
        menuStyle={{
          right: 0
        }}
      />
    </div>
  )
}

export default NavUserDropdown
